import React from "react";

export const Product = ({ color = "white" }) => {
  return (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 0.9375L13 4.1875V12.3125L6.5 15.5547L0 12.3125V4.1875L6.5 0.9375ZM11.3828 4.5L6.5 2.0625L4.61719 3L9.46875 5.45312L11.3828 4.5ZM6.5 6.9375L8.35938 6.01562L3.5 3.5625L1.61719 4.5L6.5 6.9375ZM1 5.3125V11.6875L6 14.1875V7.8125L1 5.3125ZM7 14.1875L12 11.6875V5.3125L7 7.8125V14.1875Z"
        fill={color}
      />
    </svg>
  );
};
